import React, { useState, useRef, useMemo } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { TextField, RaisedButton } from 'material-ui'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import Header from '../../components/Header/Header'
import CommonLoader from '../../components/CommonLoader/CommonLoader'
import EntityTable from '../../components/CommonEntityTable/EntityTable'
import Dialog from '../../components/Dialog/Dialog'
import DialogContent from './DialogContent'
import {
  getYesBankWalletInfo,
  getSellerWalletInfo,
  handleYesBankWalletTransfer,
  handleSellerWalletTransfer
} from '../../actions/yesBankWalletTransfer'
import Constants from '../../utils/CommonConstants'

if (process.env.WEBPACK) {
  require('./TransferWallet.css')
}

const mapStateToProps = state => ({
  isFetching: state.isFetching
})

const mapDispatchToProps = dispatch => ({
  dispatch,
  getYesBankWalletInfo: bindActionCreators(getYesBankWalletInfo, dispatch),
  getSellerWalletInfo: bindActionCreators(getSellerWalletInfo, dispatch),
  handleYesBankWalletTransfer: bindActionCreators(
    handleYesBankWalletTransfer,
    dispatch
  ),
  handleSellerWalletTransfer: bindActionCreators(
    handleSellerWalletTransfer,
    dispatch
  )
})
function TransferWallet(props) {
  const {
    isFetching,
    getYesBankWalletInfo,
    getSellerWalletInfo,
    handleYesBankWalletTransfer,
    handleSellerWalletTransfer
  } = props
  const dialogContentRef = useRef()
  const [isYesBankClearedBucket, setIsYesBankClearedBucket] = useState(true)
  const [openTransferWalletDialog, setOpenTransferWalletDialog] =
    useState(false)
  const [accountNumber, setAccountNumber] = useState('')
  const [yesBankWalletDetails, setYesBankWalletDetails] = useState(null)
  const [sellerWalletDetails, setSellerWalletDetails] = useState(null)
  const [accountNumberError, setAccountNumberError] = useState('')
  const [transferWalletFormData, setTransferWalletFormData] = useState({
    destinationAccountNumber: '',
    transferReason: '',
    yesBankResponseId: ''
  })
  const [transferType, setTransferType] = useState('yesBank')

  const transferOptions = [
    { value: 'yesBank', label: 'Yes Bank Wallet Transfer' },
    { value: 'sellerWallet', label: 'Seller Wallet Transfer' }
  ]

  const bucketData = useMemo(() => {
    if (transferType === 'yesBank') {
      if (isYesBankClearedBucket) {
        return yesBankWalletDetails && yesBankWalletDetails.clearedBucket
          ? yesBankWalletDetails.clearedBucket
          : []
      }
      return yesBankWalletDetails && yesBankWalletDetails.bouncedBucket
        ? yesBankWalletDetails.bouncedBucket
        : []
    }
    return sellerWalletDetails || []
  }, [
    isYesBankClearedBucket,
    yesBankWalletDetails,
    sellerWalletDetails,
    transferType
  ])

  const handleTransferTypeChange = (event, value) => {
    setTransferType(value)
    setSellerWalletDetails(null)
    setYesBankWalletDetails(null)
  }

  const handleCloseTransferDialog = () => {
    setOpenTransferWalletDialog(false)
  }
  const handleOpenTransferDialog = () => {
    setOpenTransferWalletDialog(true)
  }

  const handleTransferWalletFormDataChange = data => {
    const { destinationAccountNumber, transferReason } = data
    setTransferWalletFormData(prevState => ({
      ...prevState,
      destinationAccountNumber,
      transferReason
    }))
  }
  const handleYesBankBucketChange = () => {
    setIsYesBankClearedBucket(prevState => !prevState)
  }
  const handleTransferSubmit = event => {
    event.preventDefault()
    if (dialogContentRef.current && !dialogContentRef.current.validateForm()) {
      return
    }
    if (transferType === 'yesBank') {
      handleYesBankWalletTransfer(transferWalletFormData)
    } else if (transferType === 'sellerWallet') {
      handleSellerWalletTransfer(transferWalletFormData)
    }
    handleCloseTransferDialog()
  }

  const handleSubmit = event => {
    event.preventDefault()
    if (!accountNumber) {
      setAccountNumberError('Account Number is required')
      return
    }
    if (transferType === 'yesBank') {
      getYesBankWalletInfo(accountNumber).then(data => {
        setYesBankWalletDetails(data)
        setIsYesBankClearedBucket(true)
      })
    } else {
      getSellerWalletInfo(accountNumber).then(data => {
        setSellerWalletDetails(data)
      })
    }
  }
  const columns =
    transferType === 'yesBank'
      ? isYesBankClearedBucket
        ? Constants.entityTableFields.YESBANKWALLETCLEARED
        : Constants.entityTableFields.YESBANKWALLETBOUNCED
      : Constants.entityTableFields.SELLERWALLET

  const transferAmountColumn = {
    label: 'Transfer Amount',
    key: 'action',
    type: 'button',
    clickAction: data => {
      const responseId =
        transferType === 'yesBank' ? data.yesBankResponseId : data.id
      setTransferWalletFormData(prevState => ({
        ...prevState,
        responseId
      }))
      handleOpenTransferDialog()
    }
  }

  const columnsToShow = [...columns, transferAmountColumn]

  const linkText = isYesBankClearedBucket
    ? 'Click here to see Bounced Payments'
    : 'Go Back to Cleared Payments'
  const showBouncedBucketLink = !!(
    yesBankWalletDetails &&
    yesBankWalletDetails.bouncedBucket &&
    yesBankWalletDetails.bouncedBucket.length
  )
  const showData = !!(yesBankWalletDetails || sellerWalletDetails)
  return (
    <div>
      <Header {...props} />
      <div className='main-conatainer'>
        <RadioButtonGroup
          name='transferType'
          valueSelected={transferType}
          onChange={handleTransferTypeChange}
        >
          {transferOptions.map(option => (
            <RadioButton
              key={option.value}
              value={option.value}
              label={option.label}
            />
          ))}
        </RadioButtonGroup>
        <form className='form-container' onSubmit={handleSubmit}>
          <TextField
            floatingLabelText='Account Number'
            type='number'
            value={accountNumber}
            onChange={event => {
              setAccountNumberError('')
              if (event.target.value.length <= 10)
                setAccountNumber(event.target.value)
            }}
            errorText={accountNumberError}
          />
          <RaisedButton type='submit' label='Submit' primary />
        </form>
      </div>
      {isFetching && <CommonLoader />}
      {showData && (
        <div>
          {showBouncedBucketLink && (
            <button
              className='switchPaymentButton'
              onClick={handleYesBankBucketChange}
            >
              {linkText}
            </button>
          )}
          <EntityTable columns={columnsToShow} data={bucketData} />
        </div>
      )}
      <Dialog
        title='Transfer Amount'
        handleOpen={openTransferWalletDialog}
        handleClose={handleCloseTransferDialog}
        handleSubmit={handleTransferSubmit}
        dialogContent={
          <DialogContent
            ref={dialogContentRef}
            handleTransferWalletFormDataChange={
              handleTransferWalletFormDataChange
            }
          />
        }
      />
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferWallet)



/** WEBPACK FOOTER **
 ** ./src/containers/TransferWallet/TransferWallet.js
 **/